import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { ImageSliderComponent } from '../image-slider/image-slider.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ImageDialogOpts } from '../../models/image-dialog-options';

@Component({
  selector: 'app-image-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ImageSliderComponent,
    MatIconModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './image-dialog.component.html',
  styleUrl: './image-dialog.component.scss'
})

export class ImageDialogComponent {
  /**
   * Opens the dialog and asks the user to confirm
   * @param  {MatDialog} dialog
   * @param  {{message:string}} data
   * @returns Observable<boolean>
   */
  public static open(dialog: MatDialog, data: ImageDialogOpts): Observable<boolean> {
    const dialogRef = dialog.open(ImageDialogComponent, { data });
    return dialogRef.afterClosed().pipe(
      map((didConfirm: true | undefined) => !!didConfirm)
    );
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: ImageDialogOpts) {}
}
